import { cx } from "class-variance-authority";
import { Clamp } from "../Clamp/Clamp";
import * as styles from "./Live.module.scss";

const Live = () => {
  return <Clamp className={cx(styles.live)}>LIVE</Clamp>;
};

export { Live };
